import { createFileRoute, Outlet } from "@tanstack/react-router";
import { noindexHead } from "@/lib/seo";

export const Route = createFileRoute("/auth/_authLayout")({
  component: AuthLayout,
  head: () => noindexHead("Account | Lutely"),
});

function AuthLayout() {
  return <Outlet />;
}
